export type VenueOption = {
  id: string;
  name: string;
};

export const mapVenueOptions = (venues: Array<{ id: string; name: string }>): VenueOption[] =>
  venues.map(venue => ({
    id: venue.id,
    name: venue.name,
  }));

export const resolveSelectedVenueId = ({
  venues,
  preferredVenueIds,
}: {
  venues: VenueOption[];
  preferredVenueIds: string[];
}): string | null => {
  const preferredVenueId = preferredVenueIds[0];
  if (preferredVenueId && venues.some(venue => venue.id === preferredVenueId)) {
    return preferredVenueId;
  }

  return null;
};

export const resolveSelectedVenueName = ({
  venues,
  preferredVenueIds,
  venueGroupName,
}: {
  venues: VenueOption[];
  preferredVenueIds: string[];
  venueGroupName: string | null;
}): string => {
  const selectedVenueId = resolveSelectedVenueId({ venues, preferredVenueIds });

  if (!selectedVenueId) {
    if (venues.length === 0) {
      return venueGroupName ?? 'All Venues';
    }

    if (venues.length === 1) {
      return venues[0]?.name ?? venueGroupName ?? 'All Venues';
    }

    return 'All Venues';
  }

  const selectedVenue = venues.find(venue => venue.id === selectedVenueId);

  return selectedVenue?.name ?? venueGroupName ?? 'All Venues';
};
